const ContactUs = () => {
  return (
    <>
      <div className="mx-20 text-justify p-4 mt-1 rounded-2xl w-1/2 h-96"
      >
        <h1 className='text-3xl font-bold'> Head Office: </h1>
        <p>For more information on our product and services please contact us at:</p>
        <h1>eBhasha Setu Language Services private Ltd.</h1>

        <p>Vindhya B5-106 & B5-107 Ground Floor,
        </p>
        <p>IIIT-H Campus, Survey no. 25,
        </p>
        <p>Gachibowli, Hyderabad-500032
        </p>
        <p> <span className="">Phone:</span> +91-9968036443
        </p>
        <p><span className="">Email ID:</span>  info@ebhashasetu.com
        </p>
      </div>
    </>
  )
}

export default ContactUs